/** Minimum footer height in px (desktop single-line layout). */
export const LAYOUT_FOOTER_MIN_HEIGHT_PX = 44;

/**
 * CSS custom property published by LayoutFooter with its measured height.
 * Sticky chrome (e.g. Create Template save bar) sits above the footer via this.
 */
export const LAYOUT_FOOTER_HEIGHT_VAR = '--layout-footer-height';

/**
 * Tailwind class: pin an element above LayoutFooter as its height changes.
 * Must be a full literal string so Tailwind's content scanner can emit the rule.
 * No comma fallback — commas break Tailwind arbitrary-value parsing.
 */
export const LAYOUT_FOOTER_OFFSET = 'bottom-[var(--layout-footer-height)]';

export const setLayoutFooterHeightDefault = () => {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (!root.style.getPropertyValue(LAYOUT_FOOTER_HEIGHT_VAR)) {
    root.style.setProperty(
      LAYOUT_FOOTER_HEIGHT_VAR,
      `${LAYOUT_FOOTER_MIN_HEIGHT_PX}px`
    );
  }
};
